import type { ReactNode } from "react";

/** Общий инлайн-шелл для intent-панели (модалок в проекте нет). */
export function IntentPanel({
  title,
  subtitle,
  onClose,
  children,
}: {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <section className="rf-section" style={{ marginTop: 12 }}>
      <div
        className="rf-section__head"
        style={{ display: "flex", alignItems: "center", gap: 8 }}
      >
        <span style={{ flex: 1 }}>{title}</span>
        <button
          type="button"
          className="mt-btn mt-btn--sm mt-btn--ghost"
          onClick={onClose}
          aria-label="Закрыть"
        >
          ✕
        </button>
      </div>
      <div className="rf-section__body">
        {subtitle && (
          <div
            className="mt-muted"
            style={{ marginBottom: 10, fontSize: "var(--fs-sm)" }}
          >
            {subtitle}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
